import PinState from "../components/bowling/PinState.vue";
import RoundScore from "../components/bowling/RoundScore.vue";

const bowlingRoutes = [
  {
    path: "/pinState",
    name: "pinState",
    component: PinState,
  },
  {
    path: "/roundScore",
    name: "roundScore",
    component: RoundScore,
  },
];

export default bowlingRoutes;
